export default "__VITE_ASSET__C4fm7NbP__"